<template>
  <v-card
    outlined
    tile
    class="mt-5"
  >
    <v-toolbar
      color="grey lighten-3"
      flat
    >
      <v-toolbar-title>
        {{ $t('Volume') }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <p class="caption">Filter producten op basis van volume. Er wordt altijd een 'OF'-zoekopdracht uitgevoerd.</p>
      <div class="d-flex">
        <v-autocomplete
          :items="allVolumes"
          :search-input.sync="volumeInput"
          :placeholder="$t('Search')"
          :label="$t('Search')"
          v-model="searchParams.selectedVolumes"
          auto-select-first
          chips
          class="volume-autocomplete"
          deletable-chips
          flat
          hide-details
          hide-selected
          inline
          item-text="name"
          item-value="id"
          multiple
          outlined
          single-line
          small-chips
          @change="onChange"
        >
          <template slot="label">
            <v-icon
              dense
              class="mr-1"
            >fal fa-search</v-icon>
            {{ $t('Search a {0}', [$t('Volume').toLowerCase()]) }}
          </template>
        </v-autocomplete>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import attributeService from '@/services/attributes'
export default {
  name: 'VolumeFilter',
  data: () => ({
    allVolumes: [],
    volumeInput: '',
    searchParams: {
      selectedVolumes: []
    }
  }),
  mounted () {
    // Get all volumes to use in autocomplete
    // Sort by numeric value
    attributeService.attributeOptionsByCode('eliquid_volume')
      .then(data => {
        this.allVolumes = data.data.options.sort((a, b) => {
          const aNum = parseInt(a.name.replace(/[^0-9,]/g, '').replace(',', ''))
          const bNum = parseInt(b.name.replace(/[^0-9,]/g, '').replace(',', ''))
          return aNum - bNum
        })
      })
      .catch(data => {
        if (data && data.message) this.helpers.toastError(data.message)
      })
  },

  methods: {
    onChange () {
      this.volumeInput = ''
      this.$emit('change', this.searchParams)
    },
    reset () {
      this.searchParams = {
        selectedVolumes: []
      }
      this.onChange()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vapevault/filters/VolumeFilter.vue